import CollectorLinkForm from "./CollectorLinkForm";
import {useState} from "react";

const CreateCollectorLink = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Collector Link", url: "/collector-links"},
        {content: "Add Collector Link", url: ""},
    ]);

    return (
        <>
            <CollectorLinkForm crumbs={crumbs} title={"Add Collector Link"} btnText={"Create"}/>
        </>
    )
}
export default CreateCollectorLink;